import { topicItems } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">当前最受关注的网红黑料话题标签</p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.name}
              href="#"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/60 text-foreground-600 hover:border-primary-200/50 hover:text-primary-600'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-accent-500"></i>}
              <span>{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}